import type { Route } from "@route-types/Keywords/+types/Keywords";
import PageArticleList from "@src/app/components/ArticleList/PageArticleList";
import { createMetaTags } from "@src/app/components/MetaTags/MetaTags";
import {
  parsePayload,
  useRouteResponse,
} from "@src/app/hooks/useRouteResponse";
import type { KeywordsPageResponse } from "@src/app/types/response";

import { fetchKeywordPageData } from "./Keywords.server";

export const loader = fetchKeywordPageData;

export const meta = (args: Route.MetaArgs) => {
  const params = args.params;
  const keyword = params.keyword || "";
  const payload = parsePayload<KeywordsPageResponse>(args.loaderData);
  const tagName = payload.tagName || "";

  return createMetaTags({
    title: `关键词：${tagName} - 红蚂蚁`,
    description: `关键词：${tagName} 相关文章 - 《红蚂蚁》以生动的笔调撰写独立观点，以新颖的手法呈现新闻，让读者被咬得直呼过瘾。`,
    canonical: `https://www.redants.sg/keyword/${keyword}`,
  });
};

export default function KeywordsPage() {
  const route = useRouteResponse("keywordPage");

  const tagName = route.tagName || "";
  const tagId = route.tagId || "";

  console.log("KeywordsPage", tagName, tagId);
  return (
    <PageArticleList
      initialData={route.articles || []}
      title={tagName}
      requestPath={`/keyword/${tagId}`}
      className="lg:px-[24px]"
    />
  );
}
